import { taggedTemplateLiteral as _taggedTemplateLiteral, slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import themes from '../../theming/themes.js';
import React, { useState, Children } from 'react';
import _Icon from '../Icon/index.js';
import { Link } from 'react-router-dom';
import useWindowSize from '../../hooks/useWindowSize.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var BreadcrumbList = styled__default.ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    flex-wrap: wrap;\n"])));
var MoreButton = styled__default.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    background: none;\n    color: #244F8B;\n    border: none;\n    &:hover {\n        cursor: pointer;\n        text-decoration: underline;\n    }\n"])));
var BreadcrumbItem = styled__default.li(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-top: 0;\n"])));
var LastBreadcrumbItem = styled__default.li(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.secondaryDark;
});
var Breadcrumb = function Breadcrumb(_ref2) {
  var url = _ref2.url,
    children = _ref2.children,
    _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? themes["default"] : _ref2$theme,
    onClick = _ref2.onClick;
  return url ? /*#__PURE__*/React.createElement(BreadcrumbItem, null, /*#__PURE__*/React.createElement(Link, {
    onClick: onClick,
    to: url,
    className: "p-1 mx-1"
  }, children), /*#__PURE__*/React.createElement(_Icon, {
    color: 'secondaryDark',
    name: "arrow-right",
    size: "xs"
  })) : /*#__PURE__*/React.createElement(LastBreadcrumbItem, {
    theme: theme,
    "data-url": url,
    "aria-current": "page",
    className: "mt-0 ml-2"
  }, /*#__PURE__*/React.createElement("strong", null, children));
};
var HomeBreadcrumb = function HomeBreadcrumb(_ref3) {
  var url = _ref3.url,
    onClick = _ref3.onClick;
  return /*#__PURE__*/React.createElement(BreadcrumbItem, null, /*#__PURE__*/React.createElement(Link, {
    to: url,
    onClick: onClick,
    "aria-label": "Home",
    className: "p-1 mx-1"
  }, /*#__PURE__*/React.createElement(_Icon, {
    "aria-hidden": true,
    role: "img",
    "data-testid": 'home-icon',
    name: "home",
    color: 'secondaryDark'
  })), /*#__PURE__*/React.createElement(_Icon, {
    color: 'secondaryDark',
    name: "arrow-right",
    size: "xs"
  }));
};
var MoreBreadcrumb = function MoreBreadcrumb(_ref4) {
  var onClick = _ref4.onClick,
    expanded = _ref4.expanded;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreadcrumbItem, null, /*#__PURE__*/React.createElement(MoreButton, {
    onClick: onClick,
    "aria-expanded": expanded,
    className: "p-1 mx-1"
  }, "..."), /*#__PURE__*/React.createElement(_Icon, {
    color: 'secondaryDark',
    name: "arrow-right",
    size: "xs"
  })));
};
var Breadcrumbs = function Breadcrumbs(_ref5) {
  var _windowSize$width;
  var children = _ref5.children;
  var windowSize = useWindowSize();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var breadcrumbs = Children.toArray(children);
  var windowWidth = (_windowSize$width = windowSize.width) !== null && _windowSize$width !== void 0 ? _windowSize$width : 0;
  var visibleBreadcrumbs = windowWidth < 768 && !expanded && breadcrumbs.length > 3 ? [breadcrumbs[0], /*#__PURE__*/React.createElement(MoreBreadcrumb, {
    onClick: function onClick() {
      return setExpanded(true);
    },
    expanded: expanded
  })].concat(_toConsumableArray(breadcrumbs.slice(-2))) : breadcrumbs;
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": "breadcrumb"
  }, /*#__PURE__*/React.createElement(BreadcrumbList, null, visibleBreadcrumbs.map(function (crumb, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, crumb);
  })));
};

export { Breadcrumb, Breadcrumbs, HomeBreadcrumb };
